import { useNavigate } from "react-router-dom";
import { LockSimple, ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";

// Shown wherever a Free Taster / expired-pass user (or logged-out visitor) hits a
// gated action (Atlas AI refine, PDF/DOCX export, plan building).
export default function LockNotice({ reason, className = "" }) {
  const navigate = useNavigate();
  const { user, loginWithGoogle } = useAuth();
  if (!reason) return null;
  const isTier = reason === "tier";
  const expired = !!user?.pass_expired;
  return (
    <div data-testid="lock-notice"
      className={`flex items-start gap-2.5 border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 ${className}`}>
      <LockSimple size={18} weight="duotone" className="shrink-0 mt-0.5 text-amber-600" />
      <div className="space-y-2">
        {isTier ? (
          <>
            <p>
              <span className="font-semibold">{expired ? "Your pass has expired." : "Xartis Pass required."}</span>{" "}
              {expired
                ? "Your plans are safe in the Read-Only Vault — renew a pass to unlock Atlas (AI refine), exports and new builds."
                : "Atlas (AI refine) and PDF / DOCX export unlock with any Xartis Pass."}
            </p>
            <button onClick={() => navigate("/pricing")} data-testid="lock-pricing-button"
              className="inline-flex items-center gap-1.5 text-xs font-semibold border border-amber-400 px-3 py-1.5 hover:bg-amber-100 transition-colors">
              See passes <ArrowRight size={12} weight="bold" />
            </button>
          </>
        ) : (
          <>
            <p><span className="font-semibold">Sign in to continue.</span> Atlas and exports require an account.</p>
            <button onClick={loginWithGoogle} data-testid="lock-signin-button"
              className="inline-flex items-center gap-1.5 text-xs font-semibold border border-amber-400 px-3 py-1.5 hover:bg-amber-100 transition-colors">
              Continue with Google
            </button>
          </>
        )}
      </div>
    </div>
  );
}
